<template>
  <div>
    <PCNavbar selectIndex="5"/>
    <MobileNavBar :currentActive="5" />
<!--    <router-view></router-view>-->
    <About />
  </div>
</template>

<script>
import About from '@/components/realize/index'
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    About
  },
}
</script>

